var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import Plugin, { hooksDescriptor, Events, POSITIONS, Sniffer, STATE_CLASS, Util } from '../../plugin';
import TopBackIcon from './backicon';
var FullScreenSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="40" viewBox="2 -4 28 40"><path d="M19.173 6.861h6.798v6.798h-2.694V9.555h-4.104V6.86zm4.104 16.416v-4.104h2.694v6.798h-6.798v-2.694h4.104zM6.861 13.66V6.86h6.798v2.694H9.555v4.104H6.86zm2.694 5.514v4.104h4.104v2.694H6.86v-6.798h2.694z"/></svg>';
var ExitFullScreenSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="40" viewBox="2 -4 28 40"><path d="M21.867 10.965h4.104v2.694h-6.798V6.86h2.694v4.104zm-2.694 15.006v-6.798h6.798v2.694h-4.104v4.104h-2.694zm-8.208-15.006V6.861h2.694v6.798H6.86v-2.694h4.104zM6.861 21.867v-2.694h6.798v6.798h-2.694v-4.104H6.861z"/></svg>';

var Fullscreen = function (_Plugin) {
  _inherits(Fullscreen, _Plugin);

  function Fullscreen() {
    _classCallCheck(this, Fullscreen);

    return _possibleConstructorReturn(this, (Fullscreen.__proto__ || Object.getPrototypeOf(Fullscreen)).apply(this, arguments));
  }

  _createClass(Fullscreen, [{
    key: 'beforeCreate',
    value: function beforeCreate(args) {
      if (typeof args.player.config.fullscreen === 'boolean') {
        args.config.disable = !args.player.config.fullscreen;
      }
    }
  }, {
    key: 'afterCreate',
    value: function afterCreate() {
      var _this2 = this;

      hooksDescriptor(this);
      if (this.config.disable) {
        return;
      }
      this.isFullScreen = this.player.isFullScreen;
      this.initIcons();

      this.fullSreenHandler = this.hook('fullsreen_change', this.changeFullScreen);

      this.bind('.xgplayer-fullscreen', Sniffer.device === 'mobile' ? 'touchend' : 'click', this.fullSreenHandler);

      this.on(Events.FULLSCREEN_CHANGE, function (isFullScreen) {
        _this2.changeLangTextKey(_this2.find('.xg-tips'), isFullScreen ? _this2.i18nKeys.EXITFULLSCREEN_TIPS : _this2.i18nKeys.FULLSCREEN_TIPS);
        _this2.animate(isFullScreen);
      });
      if (this.config.needBackIcon) {
        this.topBackIcon = this.player.registerPlugin({
          plugin: TopBackIcon,
          options: {
            config: {
              onClick: function onClick(e) {
                _this2.show();
                _this2.fullSreenHandler(e);
              }
            }
          }
        });
      }
      if (Sniffer.device === 'mobile') {
        window.addEventListener('orientationchange', function () {
          if (_this2.player.fullscreen && _this2.config.rotateFullscreen) {
            if (window.orientation === 90 || window.orientation === -90) {
              _this2.setRotateDeg(0);
            } else {
              _this2.setRotateDeg(90);
            }
          }
        });
      }
    }
  }, {
    key: 'registerIcons',
    value: function registerIcons() {
      return {
        fullscreen: { icon: FullScreenSvg, class: 'xg-get-fullscreen' },
        exitFullscreen: { icon: ExitFullScreenSvg, class: 'xg-exit-fullscreen' }
      };
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.unbind('.xgplayer-icon', Sniffer.device === 'mobile' ? 'touchend' : 'click', this.fullSreenHandler);
    }
  }, {
    key: 'initIcons',
    value: function initIcons() {
      var icons = this.icons;

      this.appendChild('.xgplayer-icon', icons.fullscreen);
      this.appendChild('.xgplayer-icon', icons.exitFullscreen);
    }
  }, {
    key: 'setRotateDeg',
    value: function setRotateDeg(deg) {
      var player = this.player;

      if (window.orientation === 90 || window.orientation === -90) {
        player.rotateDeg = 0;
      } else {
        player.rotateDeg = deg;
      }
    }
  }, {
    key: 'getRotateFullscreen',
    value: function getRotateFullscreen() {
      var player = this.player;

      if (player.isCssfullScreen) {
        player.exitCssFullscreen();
      }
      if (player.root.getAttribute('style')) {
        this._originCssText = player.root.style.cssText;
        player.root.removeAttribute('style');
      }
      player.addClass(STATE_CLASS.ROTATE_FULLSCREEN);
      player.fullscreen = true;
      this.setRotateDeg(90);
      this.emit(Events.FULLSCREEN_CHANGE, true);
    }
  }, {
    key: 'exitRotateFullscreen',
    value: function exitRotateFullscreen() {
      var player = this.player;

      player.removeClass(STATE_CLASS.ROTATE_FULLSCREEN);
      player.fullscreen = false;
      this._originCssText && Util.setStyleFromCsstext(player.root, this._originCssText);
      this._originCssText = '';
      this.setRotateDeg(0);
      this.emit(Events.FULLSCREEN_CHANGE, false);
    }
  }, {
    key: 'changeFullScreen',
    value: function changeFullScreen(e) {
      e.preventDefault();
      e.stopPropagation();
      var player = this.player,
          config = this.config;

      var useCssFullscreen = false;
      if (config.useCssFullscreen === true || typeof config.useCssFullscreen === 'function' && config.useCssFullscreen()) {
        useCssFullscreen = true;
      }
      if (useCssFullscreen) {
        if (player.fullscreen) {
          player.fullscreen = false;
          player.exitCssFullscreen();
          this.emit(Events.FULLSCREEN_CHANGE, false);
        } else {
          player.fullscreen = true;
          player.getCssFullscreen();
          this.emit(Events.FULLSCREEN_CHANGE, true);
        }
        this.animate(player.fullscreen);
      } else if (config.rotateFullscreen) {
        if (player.fullscreen) {
          this.exitRotateFullscreen();
        } else {
          this.getRotateFullscreen();
        }
        this.animate(player.fullscreen);
      } else {
        if (config.switchCallback && typeof config.switchCallback === 'function') {
          config.switchCallback(this.isFullScreen);
          this.isFullScreen = !this.isFullScreen;
          return;
        }
        if (player.fullscreen) {
          player.exitFullscreen(config.target);
        } else {
          player.getFullscreen(config.target);
        }
      }
    }
  }, {
    key: 'animate',
    value: function animate(isFullScreen) {
      isFullScreen ? this.setAttr('data-state', 'full') : this.setAttr('data-state', 'normal');
      if (this.topBackIcon) {
        if (isFullScreen) {
          this.topBackIcon.show();
          this.hide();
        } else {
          this.topBackIcon.hide();
          this.show();
        }
      }
    }
  }, {
    key: 'show',
    value: function show() {
      _get(Fullscreen.prototype.__proto__ || Object.getPrototypeOf(Fullscreen.prototype), 'show', this).call(this);
    }
  }, {
    key: 'hide',
    value: function hide() {
      _get(Fullscreen.prototype.__proto__ || Object.getPrototypeOf(Fullscreen.prototype), 'hide', this).call(this);
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.config.disable) {
        return;
      }
      var langKey = 'FULLSCREEN_TIPS';
      return '<xg-icon class="xgplayer-fullscreen">\n    <div class="xgplayer-icon">\n    </div>\n    <div class="xg-tips" lang-key="' + this.i18nKeys[langKey] + '">' + this.i18n[langKey] + '</div>\n    </xg-icon>';
    }
  }], [{
    key: 'pluginName',
    get: function get() {
      return 'fullscreen';
    }
  }, {
    key: 'defaultConfig',
    get: function get() {
      return {
        position: POSITIONS.CONTROLS_RIGHT,
        index: 0,
        useCssFullscreen: false,
        rotateFullscreen: false,
        switchCallback: null,
        target: null,
        disable: false,
        needBackIcon: false
      };
    }
  }]);

  return Fullscreen;
}(Plugin);

export default Fullscreen;